import { useNavigate } from 'react-router-dom';

import { loginLogic, toastLogic } from '@_features/auth';
import { useContentListStateStore } from '@_features/content';
import { useFolderListItemOptionsModal } from '@_features/folder';

import { TFolder } from '@_entities/content';

import { KebabIcon } from '@_shared/icons';
import { eventPush } from '@_shared/libs';
import { SkeletonUI } from '@_shared/ui';
import { Typography } from '@_shared/ui/Typography';

import * as S from './FolderListItem.style';

export function FolderListItem({ id, name, count }: TFolder) {
	const navigate = useNavigate();
	const { clearFolderState } = useContentListStateStore();

	const { openFolderOptionsModal } = useFolderListItemOptionsModal({
		folderId: String(id),
	});

	function onClickOptionIcon(e: React.MouseEvent<HTMLDivElement>) {
		e.stopPropagation();
		openFolderOptionsModal();
	}

	return (
		<S.FolderItem
			key={`${id} folder`}
			onClick={() => {
				if (loginLogic.isLogin()) {
					eventPush(`${name}.폴더.click`);
					clearFolderState(id);
					navigate(`folder/${id}`);
				} else {
					toastLogic.loginToast();
				}
			}}
		>
			{loginLogic.isLogin() && (
				<S.IconWrapper onClick={onClickOptionIcon}>
					<KebabIcon />
				</S.IconWrapper>
			)}

			<S.FolderNameWrapper>
				<Typography type="title-large" color="font-primary" noOfLine={1}>
					{name}
				</Typography>
			</S.FolderNameWrapper>

			<Typography type="title-mini" color="font-tertiary">
				{count}개
			</Typography>
		</S.FolderItem>
	);
}

export function FolderListItemSkeleton() {
	return <SkeletonUI width="100%" height="74px" borderRadius="8px" />;
}
